export const Blue = '#0099CE';
export const White = '#FFF';
export const LightBlue = '#E4ECF3';
export const Red = '#D20020';

export const greyThree = '#DDD';
export const greySeven = '#CED6DE';
export const primaryOne = '#073142';
